import { BaseRouteService } from 'core/services';

class ImportValidationRouteService extends BaseRouteService {
    constructor() {
        super('import-validations');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,patientGroupId,importHeaderId}', filter);
    }

    bulkUpdate(resource) {
        return super.update(this.base + '/batch', resource);
    }
}

export default ImportValidationRouteService;
